import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { BiMessageAltError } from 'react-icons/bi';

import client from '../../../lib/feathers';
import MobilePersonalNoticeDetail from '../MobilePersonalNoticeDetail';
import styles from './MobilePersonalNotice.module.scss';

const FeedbackFrontDeskList = () => {
  const message = client.service('message');
  const [messageArr, setMessageArr] = useState([]);
  const [isShowPersonalNoticeDetail, setIsShowPersonalNoticeDetail] =
    useState(false);
  const [personalNoticeDetail, setPersonalNoticeDetail] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const data = await client.reAuthenticate();
        const res = await message.find({
          query: {
            title: '個人通知',
            userId: data.user._id,
            $sort: {
              createdTime: -1,
            },
          },
        });
        setMessageArr(res.data);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [message]);

  const showPersonalNoticeDetail = (data) => {
    updateIsShowPersonalNoticeDetail(true);
    updatePersonalNoticeDetail(data);
  };

  const updateIsShowPersonalNoticeDetail = (isShowDetail) => {
    setIsShowPersonalNoticeDetail(isShowDetail);
  };

  const updatePersonalNoticeDetail = (newPersonalNoticeDetail) => {
    setPersonalNoticeDetail(newPersonalNoticeDetail);
  };

  const markAsRead = async (id) => {
    try {
      await message.patch(id, { readed: true });
    } catch (error) {
      console.error('修改已讀失敗:', error);
    }
  };

  return (
    <>
      {messageArr.length === 0 && (
        <div className={styles.noData}>
          <BiMessageAltError className={styles.noDataIcon} />
          <p className={styles.noDataText}>暫無訊息</p>
        </div>
      )}
      {messageArr.length > 0 && isShowPersonalNoticeDetail ? (
        <>
          <div className={styles.background} />
          <MobilePersonalNoticeDetail
            personalNoticeDetail={personalNoticeDetail}
            updateIsShowPersonalNoticeDetail={updateIsShowPersonalNoticeDetail}
            updatePersonalNoticeDetail={updatePersonalNoticeDetail}
          />
        </>
      ) : (
        <div className={styles.mobileCalendar}>
          <div className={styles.mobileCalendarBackground} />
          <div className={styles.itemBottom}>
            {messageArr.map((list, index) => {
              return (
                <div
                  key={index}
                  className={styles.rowItems}
                  onClick={async () => await markAsRead(list._id)}
                >
                  <p className={styles.title}>
                    <span className={styles.icons}>
                      {moment(list.createdTime).format('YYYY-MM-DD HH:mm:ss')}
                    </span>
                  </p>
                  <a
                    className={styles.content}
                    onClick={() => showPersonalNoticeDetail(list)}
                  >
                    {list.content}
                  </a>
                  <hr className={styles.bcolor} />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackFrontDeskList;
